// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.6687 8.02709L15.8574 0.21582L12.2591 3.81413L15.2752 6.83023L13.861 8.24445L10.8449 5.22835L8.66074 7.41248L12.4765 11.2282L11.0623 12.6424L7.24653 8.82669L5.0624 11.0108L8.0785 14.0269L6.66428 15.4411L3.64818 12.425L0.0498047 16.0234L7.86108 23.8347L23.6687 8.02709Z"}}]};

const MapRulerFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-ruler-filled',
    ref,
    icon: element,
  },
));

MapRulerFilledIcon.displayName = 'MapRulerFilledIcon';

export default MapRulerFilledIcon;
